import { IObjectTranslatable, RelationalActionTranslator, HtmlColorCodeTranslator, RelationalActionExtractor, TextAlignKindsTranslator } from ".";
import { ICalculateItemBean, ITypeDefinable, BeanTypes } from "../beans/items";
import { IItem, CalculateItem } from "../../../../domain/document/items";

import {
  Point,
  Size,
  Rectangle,
  Color,
  TextStyle,
} from "../../../../domain/drawing";

export class CalculateItemTranslator implements IObjectTranslatable {
  toItem(item: ITypeDefinable, formatId: number, groupId: number, documentId: number, executionMode: string): IItem {
    const bean = item as ICalculateItemBean;
    const result = new CalculateItem(bean.text);
    result.privateId = (bean as any).privateId; // フロントエンド独自パラメータ.
    result.uniqueKey = bean.uniqueKey;
    result.id = bean.id;
    result.sectionObjectUid = bean.sectionObjectUid;
    result.isEditable = true; // TODO:特に問題なければプロパティを削除する
    result.isAdditional = !!bean.isAdditional;
    result.isDeleted = !!bean.isDeleted;
    result.isVisible = !!bean.isVisible;
    result.typeDetail = bean.typeDetail;
    result.viewTitle = bean.viewTitle;
    result.printBehavior.shouldPrint = !!bean.printVisible;
    result.printBehavior.shouldPreview = !!bean.previewVisible;
    result.name = bean.name;
    result.actions = RelationalActionTranslator.toItems(bean.relationalItems);
    result.geometry.rectangle = new Rectangle(new Point(bean.x, bean.y), new Size(bean.width, bean.height));
    result.textStyle = new TextStyle(new Color(bean.textColor), TextAlignKindsTranslator.toKind(bean.textAlign), bean.textFontSize, bean.adjustedTextFontSize, bean.textFontName, bean.textLineHeight, false);
    result.expression = (bean.expression && bean.expression.script) ? bean.expression.script : "";
    result.referenceIds = (bean.expression && bean.expression.referenceIds) ? bean.expression.referenceIds.sort() : [];
    result.referenceNames = (bean.expression && bean.expression.referenceNames) ? bean.expression.referenceNames.sort() : [];
    result.toolTip = bean.toolTip;
    result.dataValidationKind = bean.dataValidation;
    result.isFreeInputable = bean.supportedFreeText;
    result.enableLengthCheck = !!bean.lengthCheck;
    result.lengthChecklength = bean.length;
    result.upperLimit = bean.highValue;
    result.lowerLimit = bean.lowValue;
    result.upperLimitAlertColor = bean.highOverColor;
    result.lowerLimitAlertColor = bean.lowOverColor;
    result.calculateKind = bean.calculateType;
    result.roundingKind = bean.rounding;
    result.roundingPosition = bean.roundingPoint;
    result.pasteDestinations = RelationalActionExtractor.extractTextPasteParameters(result.actions);
    result.scriptExecuteParameters = RelationalActionExtractor.extractScriptExecuteParameters(result.actions);
    result.shouldInputFree = !!bean.enabledFreeText;
    result.enabledAutoAdjustFontSize = !!bean.enabledAutoAdjustFontSize;
    result.numericFormat = bean.numericDispType;
    result.supportedQuotable = true;  // V1の動作を見る限りではUI無しでtrue固定
    result.shouldQuote = true;        // V1の動作を見る限りではUI無しでtrue固定
    result.paintStyle = HtmlColorCodeTranslator.toPaintStyleFill(bean.backColor);
    result.paintStyleOnEditing = bean.isDisplayBackColorSpecified
      ? HtmlColorCodeTranslator.toPaintStyleFill(bean.displayBackColor)
      : null;
    result.dacsProcessType = bean.dacsProcessType;
    result.dacsItemName = bean.dacsItemName;
    result.dacsItemCode = bean.dacsItemCode;
    result.isNaturalViewEnable = bean.naturalView;
    result.naturalText = bean.naturalText;
    result.isCompareDateEmptyCheckEnable = bean.emptyCheck;
    return result;
  }

  toBean(item: IItem): ITypeDefinable {
    const target = item as CalculateItem;
    const bean: ICalculateItemBean = {
      type: BeanTypes.Calculate,
      uniqueKey: target.uniqueKey,
      id: target.id,
      sectionObjectUid: target.sectionObjectUid,
      name: target.name,
      isVisible: target.isVisible,
      printVisible: target.printBehavior.shouldPrint,
      previewVisible: target.printBehavior.shouldPreview,
      x: target.geometry.rectangle.x,
      y: target.geometry.rectangle.y,
      width: target.geometry.rectangle.width,
      height: target.geometry.rectangle.height,
      isAdditional: target.isAdditional,
      isDeleted: target.isDeleted,
      textColor: HtmlColorCodeTranslator.fromColor(target.textStyle.color),
      textFontName: target.textStyle.fontFamily,
      textFontSize: target.textStyle.baseFontSize,
      textLineHeight: target.textStyle.lineHeight,
      textAlign: TextAlignKindsTranslator.fromKind(target.textStyle.textAlign),
      displayBackColor: HtmlColorCodeTranslator.fromPaintStyle(target.paintStyleOnEditing),
      expression: {
        script: target.expression,
        referenceIds: target.referenceIds,
        referenceNames: target.referenceNames,
      },
      relationalItems: null,  // TODO:返却する必要ある？
      toolTip: target.toolTip,
      dataValidation: target.dataValidationKind,
      supportedFreeText: target.isFreeInputable,
      text: target.value,
      lengthCheck: target.enableLengthCheck,
      length: target.lengthChecklength,
      highValue: target.upperLimit,
      lowValue: target.lowerLimit,
      highOverColor: target.upperLimitAlertColor,
      lowOverColor: target.lowerLimitAlertColor,
      calculateType: target.calculateKind,
      rounding: target.roundingKind,
      roundingPoint: target.roundingPosition,
      enabledFreeText: target.shouldInputFree,
      enabledAutoAdjustFontSize: target.enabledAutoAdjustFontSize,
      adjustedTextFontSize: target.textStyle.adjustedFontSize,
      backColor: HtmlColorCodeTranslator.fromPaintStyle(target.paintStyle),
      isDisplayBackColorSpecified: !!target.paintStyleOnEditing,
      numericDispType: target.numericFormat,
      typeDetail: target.typeDetail,
      viewTitle: target.viewTitle,
      dacsProcessType: target.dacsProcessType,
      dacsItemName: target.dacsItemName,
      dacsItemCode: target.dacsItemCode,
      naturalView: target.isNaturalViewEnable,
      naturalText: target.naturalText,
      emptyCheck: target.isCompareDateEmptyCheckEnable,
    };
    return bean;
  }
}
